<div class="items h-100" [class.empty]="newsItems?.length === 0">
    @if (newsItems.length === 0 && !loading) {
        <div class="not-found">
            <div class="text-center">Er zijn nog geen updates geplaatst</div>
        </div>
    }
    @if (newsItems?.length > 0) {
        <virtual-scroller #virtualScroll (vsEnd)="scroll($event)" [items]="newsItems" class="item-list">
            @for (newsItem of virtualScroll.viewPortItems; track newsItem) {
                <div class="item" routerLink="/{{ Routenames.news }}/{{ newsItem.slug }}">
                    <app-codalt-image
                        [path]="newsItem.id + '/' + newsItem.image"
                        [thumb]="newsItem.image_thumb"
                        [adapt]="newsItem.adapt_image"
                        class="detail__image">
                    </app-codalt-image>
                    <div [class.important]="newsItem.alert" class="detail__block">
                        <h3 [class.unread]="!newsItem.read" class="item__title">{{ newsItem.title }}</h3>
                        <div class="details">
                            <time>
                                {{ newsItem.publish_date | date: 'EE d MMM yyyy HH:mm' }}
                            </time>
                            <div>
                                {{ newsItem?.customer_project?.name }}
                            </div>
                        </div>
                    </div>
                </div>
            }
            <div class="item-spacer"></div>
        </virtual-scroller>
    }
    @if (Functionalities.NewsManagement | hasFunctionality) {
        <button
            class="add-floating-button"
            color="primary"
            mat-fab
            routerLink="/{{ Routenames.news }}/{{ Routenames.newItem }}/{{ Routenames.edit }}">
            <mat-icon class="fas fa-plus"></mat-icon>
        </button>

        <button
            class="delete-button"
            color="primary"
            mat-fab
            matTooltip="{{ future ? 'Nieuws uit het verleden' : 'Toekomstig nieuws' }}"
            matTooltipPosition="before"
            [routerLink]="['/', Routenames.news, future ? '' : Routenames.future]">
            <mat-icon [class.fa-clock]="!future" [class.fa-history]="future" class="fas"></mat-icon>
        </button>
    }
</div>
<div class="router-outlet" [class.active]="childActive">
    <router-outlet (activate)="onChildActivate()" (deactivate)="onChildDeactivate($event)"></router-outlet>
</div>

<ng-template #projectFilterSearchTemplate>
    <ng-select
        [(ngModel)]="searchProjects"
        (change)="changeSearch()"
        [closeOnSelect]="false"
        [hideSelected]="true"
        [items]="projects"
        [multiple]="true"
        bindLabel="name"
        bindValue="id"
        name="customers"
        placeholder="Filter Projecten"></ng-select>
</ng-template>
